import { useState } from "react";
import { api } from "../api";
import type { Contact } from "../types";

export function ContactsCard({
  customerId,
  contacts,
  contactKinds,
  onChanged,
  flash,
}: {
  customerId: string;
  contacts: Contact[];
  contactKinds: string[];
  onChanged: () => Promise<void>;
  flash: (kind: "info" | "error", msg: string) => void;
}) {
  const [kind, setKind] = useState(contactKinds[0] ?? "wechat");
  const [value, setValue] = useState("");
  const [note, setNote] = useState("");

  const add = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!value.trim()) return;
    try {
      await api.addContact(customerId, { kind, value: value.trim(), note: note.trim() });
      setValue("");
      setNote("");
      await onChanged();
    } catch (err: unknown) {
      flash("error", (err as Error).message);
    }
  };

  const remove = async (c: Contact) => {
    try {
      await api.removeContact(customerId, c.kind, c.value);
      await onChanged();
    } catch (err: unknown) {
      flash("error", (err as Error).message);
    }
  };

  return (
    <section className="card px-5 py-4">
      <h3 className="text-sm font-semibold">联系方式</h3>
      <form
        onSubmit={add}
        className="mt-3 grid grid-cols-[6rem_1fr_1fr_auto] gap-2"
      >
        <select className="select" value={kind} onChange={(e) => setKind(e.target.value)}>
          {contactKinds.map((k) => (
            <option key={k} value={k}>
              {k}
            </option>
          ))}
        </select>
        <input
          className="input"
          placeholder="账号 / 号码"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <input
          className="input"
          placeholder="备注（可选）"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <button className="btn-primary" type="submit">
          添加
        </button>
      </form>
      {contacts.length === 0 ? (
        <p className="mt-3 text-sm text-ink-500">还没添加联系方式</p>
      ) : (
        <ul className="mt-3 divide-y divide-ink-100 rounded-md border border-ink-200">
          {contacts.map((c, i) => (
            <li
              key={`${c.kind}-${c.value}-${i}`}
              className="flex items-center justify-between gap-2 px-3 py-1.5 text-sm"
            >
              <div className="flex items-center gap-2">
                <span className="chip font-mono">{c.kind}</span>
                <span className="font-medium">{c.value}</span>
                {c.note && <span className="text-xs text-ink-500">{c.note}</span>}
              </div>
              <button
                className="text-ink-400 hover:text-red-600"
                onClick={() => remove(c)}
                title="删除"
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
